import { differenceInDays, addDays, addHours, addMinutes } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

export const DEFAULT_PERIOD_IN_MINUTES = 15;

export const getNumberOfDays = (
  start: string | Date,
  end: string | Date,
): number => {
  let startDate = start;
  let endDate = end;
  if (typeof startDate === 'string' && typeof endDate === 'string') {
    startDate = new Date(startDate);
  }
  let numberOfDays = differenceInDays(endDate, startDate);
  if (numberOfDays < 1) {
    numberOfDays = 1;
  }

  return numberOfDays;
};

export function mapBucketToDate(bucket: number, start: string): Date {
  const startDate = zonedTimeToUtc(start, 'Europe/Madrid');

  const minutesInHour = 60;
  const hoursInDay = 24;

  const unboundHour = Math.floor(
    (bucket * DEFAULT_PERIOD_IN_MINUTES) / minutesInHour,
  );
  const hour = unboundHour % hoursInDay;
  const minutes = Math.ceil(
    (bucket * DEFAULT_PERIOD_IN_MINUTES) % minutesInHour,
  );

  const day = Math.trunc(unboundHour / hoursInDay);

  let date = addDays(startDate, day);
  date = addHours(date, hour);
  date = addMinutes(date, minutes);

  return date;
}
